import { useEffect, useState } from "react";
import { consumeMarketplaceReturn, hasMarketplaceReturn } from "./mkt-routing";
import { useT } from "../../i18n";

/**
 * BACK TO MARKETPLACE (Macro #29 Stage 3 — Phase E).
 *
 * The Grid↔Marketplace round-trip: after "VIEW ON GRID" stashed the exact
 * marketplace context (hash + scroll), this floating affordance restores it
 * one-to-one. It only appears when a return context exists, so the Grid stays
 * clean for direct visitors.
 */
export function BackToMarketplace() {
  const t = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const check = () => setShow(hasMarketplaceReturn());
    check();
    window.addEventListener("hashchange", check);
    window.addEventListener("pageshow", check);
    return () => {
      window.removeEventListener("hashchange", check);
      window.removeEventListener("pageshow", check);
    };
  }, []);

  if (!show) return null;

  const onBack = () => {
    const ret = consumeMarketplaceReturn();
    setShow(false);
    window.location.hash = ret?.hash ?? "#marketplace";
    if (ret) {
      const y = ret.scrollY;
      window.setTimeout(() => {
        try {
          window.scrollTo(0, y);
        } catch {
          /* noop */
        }
      }, 120);
    }
  };

  return (
    <button
      type="button"
      data-testid="back-to-marketplace"
      onClick={onBack}
      className="fixed left-4 top-20 z-40 inline-flex items-center gap-2 h-10 px-4 rounded-full neon-glass-strong border border-neon-teal/50 text-neon-teal font-mono text-[10.5px] font-semibold tracking-[0.16em] uppercase hover:bg-neon-teal/15 hover:shadow-glow-teal-sm transition-[background-color,box-shadow]"
    >
      {t("marketplace.demoGrid.returnToMarket")}
    </button>
  );
}
